import React, { useContext, useMemo, useState } from 'react';
import { RuleEditorContext } from '../../NodeEditorDrawer/context';
import { StyledPre } from 'flow/editor/styles';
import { RuleEditorDropdownMode, ThresholdRightAttributeOrigin } from '../../NodeEditorDrawer/types';
import { ThresholdContext } from '../context';
import { CaretIndexType } from '../../useCaretControl/constants';
import {
  computeRuleItemLengthLimit,
  getCommaDelineatedDisplayString,
  getCommaDelineatedValues,
  truncateLabelWithRemainder,
} from '../RuleThresholdDropdown/helpers';
import { BEST_EFFORT_PARSING_DEFAULT_STRING } from 'flow/service/thresholds';

export const ListInclusionItem = ({ rulePath }: { rulePath: string }) => {
  const {
    threshold,
  } = useContext(ThresholdContext);

  const {
    getFlattenedCaretPositionIndex,
    ruleEditorPanelBoxContainerWidth,
    setIsolatedEditingBlock,
  } = useContext(RuleEditorContext);

  const [isHighlighted, setIsHighlighted] = useState(false);

  const flattenedPathInCaretPositionFormat = useMemo(() => getFlattenedCaretPositionIndex({
    itemPath: rulePath,
    mode: RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE_VALUE,
    type: CaretIndexType.RULES,
  }), [getFlattenedCaretPositionIndex, rulePath]);

  const onClick = () => (
    setIsolatedEditingBlock({
      originPublicId: threshold.publicId,
      originCaretIndex: flattenedPathInCaretPositionFormat,
      originType: ThresholdRightAttributeOrigin.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_LIST_INCLUSION,
    })
  );

  const Label = useMemo(() => {
    if (!threshold.right.attributeValue) {
      return (
        <StyledPre style={{ color: 'var(--cl-gray-700)' }}>
          edit list...
        </StyledPre>
      );
    }

    const stringifiedValue = threshold.right.attributeValue === BEST_EFFORT_PARSING_DEFAULT_STRING
      ? '' : String(threshold.right.attributeValue);
    const delineatedValues = getCommaDelineatedValues(stringifiedValue);
    const untruncatedDisplayString = getCommaDelineatedDisplayString(delineatedValues);
    const lengthLimit = computeRuleItemLengthLimit(ruleEditorPanelBoxContainerWidth);

    return (
      <StyledPre style={{ fontWeight: 'bold' }}>
        {untruncatedDisplayString.length <= lengthLimit
          ? untruncatedDisplayString
          : truncateLabelWithRemainder(
            delineatedValues,
            lengthLimit,
          )}
      </StyledPre>
    );
  }, [ruleEditorPanelBoxContainerWidth, threshold.right.attributeValue]);

  return (
    <>
      <StyledPre>[</StyledPre>
      <StyledPre
        onClick={onClick}
        highlighted={isHighlighted}
        onMouseOver={() => setIsHighlighted(true)}
        onMouseLeave={() => setIsHighlighted(false)}
        style={{ padding: 'var(--cl-space-1)' }}
      >
        {Label}
      </StyledPre>
      <StyledPre>]</StyledPre>
    </>
  );
};
